import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {LoginService} from "../../../services/login.service";

@Component({
	selector: 'app-dialog-solicitar-acesso',
	templateUrl: './dialog-solicitar-acesso.component.html',
	styleUrls: ['./dialog-solicitar-acesso.component.scss']
})
export class DialogSolicitarAcessoComponent implements OnInit {

	constructor(public dialogRef: MatDialogRef<DialogSolicitarAcessoComponent>, @Inject(MAT_DIALOG_DATA) public data:any, private loginService: LoginService) {

	}

	ngOnInit() {

	}

	baixar(): void {
		this.loginService.downloadDocumentoSolicitacaoAcesso();
	}

}
